const subscriptionActions = {
  FETCH_SUBSCRIPTIONS: 'FETCH_SUBSCRIPTIONS',
  FETCH_SUBSCRIPTIONS_SUCCESS: 'FETCH_SUBSCRIPTIONS_SUCCESS',
  FETCH_SUBSCRIPTIONS_ERROR: 'FETCH_SUBSCRIPTIONS_ERROR',
  TOGGLE_SHOW_SUBSCRIPTION: 'TOGGLE_SHOW_SUBSCRIPTION',
  TOGGLE_SUBSCRIPTION: 'TOGGLE_SUBSCRIPTION',
  TOGGLE_SUBSCRIBE_SUCCESS: 'TOGGLE_SUBSCRIBE_SUCCESS',
  TOGGLE_UNSUBSCRIBE_SUCCESS: 'TOGGLE_UNSUBSCRIBE_SUCCESS',
  TOGGLE_SUBSCRIPTION_ERROR: 'TOGGLE_SUBSCRIPTION_ERROR',
};

export const eventSubscriptions = {
  USERS_REGISTERED: 'users-registered',
};

export default subscriptionActions;
